import { notifyExternalJobFeedChange } from './companyJobFeedService';
import { notifyCompanyInventoryChanged } from './companyInventoryEvents';

export const JOB_FEED_APPROVED_EVENT = 'rxrooster:job-feed-approved';
export const JOB_FEED_APPROVAL_MESSAGE =
  'An RxRooster admin reviewed and approved your Job Feed. It is now active and will automatically pull your anesthesia job listings.';

/** Accept the explicit new payload and the title sent by older API instances. */
export const isJobFeedApprovalNotification = (notification) =>
  notification?.type === 'job_feed_review' &&
  (notification?.data?.reviewOutcome === 'approved' ||
    notification?.actionUrl === '/company/listings' ||
    ['your job feed is live', 'your job feed was approved'].includes(
      String(notification?.title || '').trim().toLowerCase(),
    ));

export const isJobFeedSyncNotification = (notification) =>
  notification?.type === 'job_feed_sync';

/** Wake mounted feed and listing readers when a scheduled pull finishes. */
export const announceJobFeedSync = (notification) => {
  notifyExternalJobFeedChange();
  notifyCompanyInventoryChanged({
    source: 'job_feed_sync',
    feedId: notification?.data?.feedId,
    counts: notification?.data?.metadata?.counts,
  });
};

/**
 * Move every client-side reader together before the route changes. The custom
 * event is consumed inside BrowserRouter, because NotificationProvider itself
 * sits above the router and cannot use React Router navigation directly.
 */
export const announceJobFeedApproval = (notification) => {
  notifyExternalJobFeedChange();
  notifyCompanyInventoryChanged({
    source: 'job_feed_approval',
    feedId: notification?.data?.feedId,
  });

  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
    window.dispatchEvent(
      new CustomEvent(JOB_FEED_APPROVED_EVENT, {
        detail: {
          ...notification,
          message: notification?.message || JOB_FEED_APPROVAL_MESSAGE,
        },
      }),
    );
  }
};
